import { render, staticRenderFns } from "./promoteStateCell.vue?vue&type=template&id=478d2239&scoped=true"
import script from "./promoteStateCell.vue?vue&type=script&lang=js"
export * from "./promoteStateCell.vue?vue&type=script&lang=js"
import style0 from "./promoteStateCell.vue?vue&type=style&index=0&id=478d2239&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478d2239",
  null
  
)

export default component.exports